import { render, staticRenderFns } from "./InterviewGradeList.vue?vue&type=template&id=c89b3104&scoped=true"
import script from "./InterviewGradeList.vue?vue&type=script&lang=js"
export * from "./InterviewGradeList.vue?vue&type=script&lang=js"
import style0 from "./InterviewGradeList.vue?vue&type=style&index=0&id=c89b3104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b3104",
  null
  
)

export default component.exports